module.exports = __webpack_public_path__ + "static/assets/0c7ab75eeb1169d944cec17e54ce2e79.gif";